export default "__VITE_ASSET__BAfFbM7D__"